import { set } from "date-fns/set";

export const convertTimeToDate = (time: string) => {
  const [hour, minute] = time.split(":");

  return set(new Date(), { hours: +hour, minutes: +minute });
};
